<template>
    <header class="relative flex items-center justify-between lg:max-w-7xl lg:mx-auto w-full"
    :class="{'header--question': questionMode}">
        <div class="logo">
            <Logo />
        </div>
        <div class="lines absolute bottom-0 right-0 lg:relative lg:bottom-auto lg:right-auto"
        :class="{'right-100 opacity-0': questionMode}">
            <Lines />
        </div>
    </header>
</template>

<script>
import Lines from "../Components/Vector/Lines.vue";
import Logo from "../Components/Vector/Logo.vue";

export default {
	name: "HeaderElement",
	components: {Lines, Logo},
	props: {
		questionMode: Boolean
	},
};
</script>

<style lang="scss" scoped>
header {
    --title-size: 30px;
    --title-leading: 38px;
    padding: 45px;

    @media (min-width: 1024px) {
        --title-size: 42px;
        --title-leading: 50px;
        padding: 60px 0 60px 60px;
    }

    position: relative;
    z-index: 3;

    .logo {
        position: relative;
        text-transform: uppercase;
        font-weight: 900;
        font-size: var(--title-size);
        line-height: var(--title-leading);
        max-width: 300px;
        color: black;
        left: 0;
        transform: translateX(0);
        transition: font-size .4s cubic-bezier(.47,1.64,.41,.8), line-height .4s cubic-bezier(.47,1.64,.41,.8), left .4s cubic-bezier(.47,1.64,.41,.8), transform .4s cubic-bezier(.47,1.64,.41,.8);
    }

    .lines {
        transition: opacity .4s cubic-bezier(.47,1.64,.41,.8), right .4s cubic-bezier(.47,1.64,.41,.8);
    }

    &.header--question {
        --title-size: 22px;
        --title-leading: 26px;

        @media (min-width: 1024px) {
            --title-size: 30px;
            --title-leading: 38px;
            padding-left: 0;
            .logo {
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
}
</style>
